interface AuthConfigErrorProps {
  missingConfigKeys: string[];
}

/**
 * Shown at bootstrap when Entra is expected (not dev_bypass) but required
 * Entra settings are missing from the resolved runtime configuration.
 */
export function AuthConfigError({ missingConfigKeys }: AuthConfigErrorProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: 24,
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 560,
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          padding: 24,
        }}
      >
        <h2 style={{ marginTop: 0 }}>Authentication configuration error</h2>
        <p>
          The app is not in <code>dev_bypass</code> mode but required Microsoft
          Entra settings are missing or empty.
        </p>
        <p>Missing or empty:</p>
        <ul>
          {missingConfigKeys.map((v) => (
            <li key={v}>
              <code>{v}</code>
            </li>
          ))}
        </ul>
        <p>
          In a deployed environment these come from <code>/config.json</code>,
          which the frontend container writes at startup from its env file (see{" "}
          <code>infra/VM_DEPLOYMENT.md</code>). Fix the env file and restart the
          container — no rebuild is needed.
        </p>
        <p>
          For local development without Entra, set{" "}
          <code>VITE_AUTH_MODE=dev_bypass</code> in <code>.env</code>.
        </p>
      </div>
    </div>
  );
}
